import { render, staticRenderFns } from "./TemplateReviewForm.vue?vue&type=template&id=68adf037&"
import script from "./TemplateReviewForm.vue?vue&type=script&lang=js&"
export * from "./TemplateReviewForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports